// Maps suppliers to anonymous depot labels (A, B, C...) by alphabetical sort.
// All functions are pure — callers pass in the supplier list; no DB calls here.

export function getDepotMap(suppliers) {
	const sorted = [...suppliers].sort((a, b) =>
		a.toLowerCase().localeCompare(b.toLowerCase())
	);
	const map = {};
	sorted.forEach((supplier, i) => {
		map[supplier] = {
			label: `Depozit ${String.fromCharCode(65 + i)}`,
			slug: String.fromCharCode(97 + i),
		};
	});
	return map;
}

export function getDepotList(suppliers) {
	const map = getDepotMap(suppliers);
	return [...suppliers]
		.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
		.map((supplier) => ({ supplier, ...map[supplier] }));
}

export function getSupplierForSlug(suppliers, slug) {
	return getDepotList(suppliers).find((d) => d.slug === slug)?.supplier ?? null;
}
